import { NAME } from './constants';

export const LOGIN = `${NAME}/login`;
export const LOGOUT = `${NAME}/logout`;
export const LOGGED_IN = `${NAME}/loggedIn`;
export const SUBMIT_LOGIN = `${NAME}/submitLogin`;
export const SUBMIT_LOGOUT = `${NAME}/submitLogout`;
export const AUTH_ERROR = `${NAME}/authError`;
export const REGISTER = `${NAME}/register`;
export const REGISTERED = `${NAME}/registered`;
export const REGISTER_ERROR = `${NAME}/registerError`;
export const CLEAR_REGISTRATION_STATUS = `${NAME}/clearRegistrationStatus`;
export const SUBMIT_REGISTER = `${NAME}/submitRegister`;
export const REQUEST_REGISTER_CONTENT = `${NAME}/requestRegisterContent`;
export const RECEIVE_REGISTER_CONTENT = `${NAME}/receiveRegisterContent`;
export const CHANGE_PASSWORD = `${NAME}/changePassword`;
export const CHANGED_PASSWORD = `${NAME}/changedPassword`;
export const SUBMIT_CHANGE_PASSWORD = `${NAME}/submitChangePassword`;
export const ORDER_NEW_PASSWORD = `${NAME}/orderNewPassword`;
export const ORDERED_NEW_PASSWORD = `${NAME}/orderedNewPassword`;
